/* eslint-disable no-prototype-builtins */
import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { useNavigate, useParams } from 'react-router-dom'
import { Link } from 'react-router-dom'

import swipelyticsSpinnerGIF from '../../assets/swipelytics-spinner-4.gif'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import { standardSpinner, textUnderneathStandardSpinner } from '../../helpers/spinners'
import useWindowDimensions from '../../helpers/windowDimensions'
import { getPayload, getEmailFromLocalStorage, getTokenFromLocalStorage } from '../../helpers/storage.js'
import { seoPageTags, customAnalyticsEvent } from '../../helpers/analytics'
import { reloadView } from '../../helpers/globalHelpers.js'
import { mobileStepperElement, stepperElement } from '../../helpers/steppers.js'
import { standardButton } from '../../helpers/buttons.js'
import { standardErrorContainer } from '../../helpers/errors.js'
import { navbarHeight, footerHeight, positionChangeWidthSm, bottomSteps, agesArray, minimumOnboardingAboutMe, minimumOnboardingHobbies, minimumOnboardingMedia, minimumOnboardingPrompts } from '../../helpers/variableDefaults.js'
import { uploadAWSFilesArray, uploadCroppedAWSFilesArray } from '../../helpers/imageHandling.js'
import { advisoryTypography } from '../../helpers/typographies.js'
import { requiredVitalInfoExists } from '../../helpers/commonMethods.js'
import { advisoryElementJSX } from '../../helpers/commonJSX.js'

import CropNewMediaCarousel from '../user/media/CropNewMediaCarousel.js'

import { vitalInfoOnboardingJSX } from './helpers/vitalInfo.js'
import { mediaOnboardingJSX } from './helpers/media.js'
import { bioOnboardingJSX } from './helpers/bio.js'

import { Input } from '../../helpers/globalHelpers.js'

// Onboarding Master Page
const Onboarding = (props) => {

  // const { user, setUser } = props
  
  // Window Dimensions
  const { height, width } = useWindowDimensions()
  
  // Navigate
  const navigate = useNavigate()

  // Params
  const { userId } = useParams()

  // Payload
  const payload = getPayload()

  // Models
  const [user, setUser] = useState({})
  const [vitalInfoObject, setVitalInfoObject] = useState({
    firstName: '', 
    age: -1,
    gender: '',
    sexuality: '',
    pronouns: '',
    interestedIn: '',
    interestedInAgeMin: agesArray[0],
    interestedInAgeMax: agesArray[agesArray.length - 1],
    heightInches: -1,
    heightCM: -1,
    inOrCmPreference: 'in',
    currentCity: '',
    hometown: '',
    languages: [],
    religion: [],
    politics: '',
    educationLevel: '',
    university: '',
    profession: '',
    employer: ``,
    children: '',
    familyPlans: '',
    datingIntentions: '',
    relationshipType: '',
    ethnicity: '',
    alcohol: '',
    cigarettes: '',
    weed: '',
    drugs: '',
    pets: [],
    zodiac: '',
    hidden: [],
  })
  const [mediaArray, setMediaArray] = useState([])
  const [bioObject, setBioObject] = useState({
    aboutMe: [''], // Array of 'About Me' section strings
    prompts: [
      {
        prompt: '',
        response: '',
      },
      {
        prompt: '',
        response: '',
      },
      {
        prompt: '',
        response: '',
      }
    ], // Array of 'Prompt' objects; each Object has the keys: 'prompt' and 'response' 
    hobbies: ['', '', '', '', ''], // Array of 'hobbies' strings; 
  })

  // Navigation
  const [viewIndex, setViewIndex] = useState(0) // 0 — Vital Info; 1 — Media; 2 — Bio; 3 - Onboarding Complete
  const [showCropCarousel, setShowCropCarousel] = useState(false)

  // Loading
  const [loading, setLoading] = useState(false)
  const [loadingVitalInfo, setLoadingVitalInfo] = useState(false)
  const [loadingMedia, setLoadingMedia] = useState(false)
  const [loadingBio, setLoadingBio] = useState(false)

  // Errors
  const [errors, setErrors] = useState(false)
  const [vitalInfoErrors, setVitalInfoErrors] = useState(false)
  const [mediaErrors, setMediaErrors] = useState(false)
  const [bioErrors, setBioErrors] = useState(false)

  useEffect(() => {

    const getData = async () => {
      setLoading(true)
      try {
        const { data: retrievedUser } = await axios.get(`${process.env.REACT_APP_SERVER_URL}/api/users/${userId}`, {
          headers: {
            Authorization: `Bearer ${getTokenFromLocalStorage()}`,
          },
        })
        // console.log('retrieved User ->', retrievedUser)

        if (payload.sub === retrievedUser._id) {

          // Set States
          setUser(retrievedUser)

          if ('bio' in retrievedUser && retrievedUser.bio !== null && 'vitalInfo' in retrievedUser.bio && retrievedUser.bio.vitalInfo !== null && 'firstName' in retrievedUser.bio.vitalInfo) {
            setVitalInfoObject(retrievedUser.bio.vitalInfo)
          }

          if ('bio' in retrievedUser && retrievedUser.bio !== null && 'prompts' in retrievedUser.bio && retrievedUser.bio.prompts !== null && retrievedUser.bio.prompts.length > 0) {
            const newPromptsArray = [ ...retrievedUser.bio.prompts ]
            
            while (newPromptsArray.length < Math.max(minimumOnboardingPrompts, 3)) {
              newPromptsArray.push(
                {
                  prompt: '',
                  response: '',
                }
              )
            }
            setBioObject({ ...bioObject, prompts: newPromptsArray })
          }

          if (
            'bio' in retrievedUser 
            && retrievedUser.bio !== null 
            && 'vitalInfo' in retrievedUser.bio && retrievedUser.bio.vitalInfo !== null 
            && 'firstName' in retrievedUser.bio.vitalInfo
          ) {
            setViewIndex(
              !requiredVitalInfoExists(retrievedUser.bio.vitalInfo) 
                ? 
                0 
                : 
                'media' in retrievedUser 
                && retrievedUser.media !== null
                && retrievedUser.media.length < minimumOnboardingMedia 
                  ? 
                  1 
                  : 
                  2
            )
          }

          
          setErrors(false)
          setLoading(false)
        } else {
          navigate(`/`)
          setErrors(false)
          setLoading(false)
        }

      } catch (error) {
        console.log(error)

        navigate(`/`)

        setErrors(true)
        setLoading(false)
      }
    }

    getData()
    
    
  }, [])

  useEffect(() => {
    // console.log('onboarding data changed')
    // console.log('mediaArray useEffect ->', mediaArray)

  }, [vitalInfoObject, mediaArray, bioObject, viewIndex, loading, showCropCarousel])

  const resetErrorsAndLoading = () => {
    setErrors(false)
    setVitalInfoErrors(false)
    setMediaErrors(false)
    setBioErrors(false)

    // setLoading(false)
    // setLoadingVitalInfo(false)
    // setLoadingMedia(false)
    // setLoadingBio(false)
  }


  const handleSavePressed = async () => {
    console.log('handleSavePressed runs')
    resetErrorsAndLoading()

    if (viewIndex === 0) { //Uploading Vital Info
      const vitalInfoObjToUpload = { vitalInfo: { ...vitalInfoObject } }
      
      setLoading(true)

      // Upload data
      try {
        // console.log('user.bio._id ->', user.bio._id)
        // Bio Items Modifications
        // const { data } = await axios.put(`${process.env.REACT_APP_SERVER_URL}/api/bio-items/${user.bio._id}`, bioItemsToUploadObj, {
        await axios.put(`${process.env.REACT_APP_SERVER_URL}/api/bio-items/${user.bio._id}`, vitalInfoObjToUpload, {
          headers: {
            Authorization: `Bearer ${getTokenFromLocalStorage()}`,
          },
        })
        // console.log('updatedBioItems ->', data)


        // Set view to Onboarding Completed
        setViewIndex(
          'media' in user 
          && user.media !== null
          && user.media.length < minimumOnboardingMedia 
            ?
            1
            :
            'bio' in user
            && 'prompts' in user.bio
            && user.bio.prompts !== null
            && user.bio.prompts.filter(promptObj => 'prompt' in promptObj && promptObj.prompt.length > 0 && 'response' in promptObj && promptObj.response.length > 0).length < minimumOnboardingPrompts
              ?
              2
              :
              3
        )

        setErrors(false)
        setLoading(false)
      } catch (error) {
        console.log('error uploading vital info ->', error)

        setErrors(true)
        setLoading(false)
      }
      

    } else if (viewIndex === 1) {

      setLoading(true)

      // Upload Media
      const uploadedMedia = await uploadCroppedAWSFilesArray(mediaArray, 'client', `${user.email.slice(0, user.email.indexOf('@'))}`, user._id, user.email, true)

      setViewIndex(
        'bio' in user
        && 'prompts' in user.bio
        && user.bio.prompts !== null
        && user.bio.prompts.filter(promptObj => 'prompt' in promptObj && promptObj.prompt.length > 0 && 'response' in promptObj && promptObj.response.length > 0).length < minimumOnboardingPrompts
          ?
          2
          :
          3
      )
      setErrors(false)
      setLoading(false)

    } else {
      setLoading(true)
      // Bio Items Upload Object
      const promptsToUploadObj = { prompts: [ ...bioObject.prompts ] }
      // console.log('promptsToUploadObj ->', promptsToUploadObj)


      // Upload data
      try {
        // console.log('user.bio._id ->', user.bio._id)
        // Bio Items Modifications
        // const { data } = await axios.put(`${process.env.REACT_APP_SERVER_URL}/api/bio-items/${user.bio._id}`, promptsToUploadObj, {
        await axios.put(`${process.env.REACT_APP_SERVER_URL}/api/bio-items/${user.bio._id}`, promptsToUploadObj, {
          headers: {
            Authorization: `Bearer ${getTokenFromLocalStorage()}`,
          },
        })
        // console.log('updatedBioItems ->', data)

        // Set view to Onboarding Completed
        setViewIndex(3)

        setErrors(false)
        setLoading(false)
      } catch (error) {
        console.log('error uploading prompts ->', error)

        setErrors(true)
        setLoading(false)
      }

    }

    window.scrollTo(0, 0)
  }

  // const handleSkipPressed = () => {
  //   console.log('handleSkipPressed runs')

  //   navigate(`/dashboard/${payload.sub}`, { state: { previousLocationPathname: window.location.pathname } })
  // }

  const handleOnboardingCompletedPressed = () => {
    console.log('handleViewDashboardPressed runs')

    navigate(`/dashboard/${payload.sub}?onboarding-complete`, { state: { previousLocationPathname: window.location.pathname } })

    reloadView()
  }

  const errorsExist = () => {
    return (errors || vitalInfoErrors || mediaErrors || bioErrors)
  }

  const isLoading = () => {
    return (loading || loadingVitalInfo || loadingMedia || loadingBio)
  }

  const nextButtonDisabled = () => {
    // console.log('empty aboutMe ->', bioObject.aboutMe.filter(aboutMeItem => aboutMeItem.trim().length === 0).length > 0)
    return (
      (isLoading() || viewIndex >= bottomSteps.length)
      ||
      (viewIndex === 0 && !requiredVitalInfoExists(vitalInfoObject))
      ||
      (viewIndex === 1 && ('media' in user && user.media !== null && user.media.length > 0 ? user.media.length + mediaArray.length < minimumOnboardingMedia : mediaArray.length < minimumOnboardingMedia))
      ||
      (viewIndex === 2 && bioObject.prompts.filter(promptObj => 'prompt' in promptObj && promptObj.prompt.length > 0 && 'response' in promptObj && promptObj.response.length > 0).length < minimumOnboardingPrompts)
    )
  }

  const nextButtonJSX = () => {
    return (
      <>
        <Box
          sx={{
            mt: (width < positionChangeWidthSm) || (viewIndex === 1 && mediaArray.length >= minimumOnboardingMedia) ? 2 : 4, pb: (viewIndex === 1 && mediaArray.length >= minimumOnboardingMedia) ? 0 : 2,
            width: '90%', 
            // maxWidth: '450px',
            display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
          }}
        >
          {standardButton(
            viewIndex >= bottomSteps.length - 1 ? 'Save' : 'Save', 
            'button',
            'contained',
            nextButtonDisabled(),
            'warning', 
            0,
            0,
            0,
            '45%', 
            '45px', 
            handleSavePressed
          )}
        </Box>

        {/* Number of Media Items Needed Indicator */}
        {viewIndex === 1 &&
          !(
            ('media' in user && user.media !== null && user.media.length > 0 && mediaArray.length + user.media.length >= minimumOnboardingMedia)
            ||
            (mediaArray.length >= minimumOnboardingMedia)
          )
          &&
          advisoryElementJSX(
            (
              'media' in user && user.media !== null && user.media.length > 0 && mediaArray.length + user.media.length < minimumOnboardingMedia 
                ?  
                `Upload at least ${minimumOnboardingMedia - user.media.length} new media item${ minimumOnboardingMedia - user.media.length === 1 ? `` : `s`}` 
                : 
                `Upload at least ${minimumOnboardingMedia} media items` 
            ),
            'media' in user && user.media !== null && user.media.length > 0 ? mediaArray.length + user.media.length >= minimumOnboardingMedia : mediaArray.length >= minimumOnboardingMedia
          )
        }

        {mediaErrors &&
          <Box
            sx={{
              // px: 1,
              width: '90%',
            }}
          >
            {standardErrorContainer(
              'There was an error uploading at least one of your media files. Check that they meet the listed criteria and then try again.',
              1,
              1
            )}
          </Box>
        }

        {errorsExist() && !mediaErrors &&
          <Box
            sx={{
              // px: 1,
              width: '90%',
            }}
          >
            {standardErrorContainer(
              'There was an error uploading your data. Check your Internet connection and then try again.',
              1,
              1
            )}
          </Box>
        }

        {/* MobileStepper */}
        {mobileStepperElement(viewIndex, bottomSteps.length, 'dodgerBlue', 0, (viewIndex === 1 && mediaArray.length >= minimumOnboardingMedia) ? 0 : 2, 400)}
      </>
    )
  }

  return (
    <>
      {/* Helmet — for analytics, seo, and page title changing */}
      {seoPageTags(
        'Onboarding'
      )}

      {/* Body */}
      <Box 
        sx={{ 
          minHeight: `calc(100vh - ${navbarHeight} - ${footerHeight})`, 
          width: '100vw', 
          display: 'flex', flexDirection: 'column', justifyContent: loading || viewIndex === 3 ? 'center' : 'flex-start', alignItems: 'center', 
        }}
      >
        {loading ?
          (viewIndex === bottomSteps.length - 1) ? textUnderneathStandardSpinner(`It may take a minute for all of your media to upload, especially videos`) : standardSpinner()
          :
          showCropCarousel > 0 ?
            <CropNewMediaCarousel isDemo={false} fromComponent={'onboarding'} newMediaArray={mediaArray} setNewMediaArray={setMediaArray} mediaArray={mediaArray} setMediaArray={setMediaArray} user={user} showCropCarousel={showCropCarousel} setShowCropCarousel={setShowCropCarousel} width={width} />
            :
            viewIndex === 3 ?
              <>
                <Box
                  sx={{
                    fontWeight: 'bold',
                    fontSize: '18px',
                  }}
                >
                  Onboarding complete
                </Box>

                {bottomSteps.length > 2 && advisoryTypography(
                  `*It may take a minute for all of your media to upload, especially videos`
                )}

                {standardButton(
                  'OK', 
                  'button',
                  'contained',
                  false,
                  'primary', 
                  bottomSteps.length > 2 ? 0 : 2,
                  0,
                  0,
                  '200px', 
                  '45px', 
                  handleOnboardingCompletedPressed
                )}
              </>
              :
              <>
                {/* Vital Info, Media, Or Bio with buttons and mobile stepper */}
                <Box
                  sx={{
                    py: 3, my: 3,
                    width: '90%',
                    maxWidth: '600px',
                    backgroundColor: 'whitesmoke',
                    borderRadius: 3, boxShadow: 3,
                    display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
                  }}
                >
                  <Typography 
                    sx={{ 
                      mt: 0, fontSize: '18px', 
                      fontWeight: 'bold',
                      display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
                    }}
                  >
                    Getting Started
                  </Typography>
                  
                  <Typography 
                    textAlign={'center'}
                    sx={{ 
                      mt: 1, 
                      // mb: bottomSteps.length > 2 ? 1 : 2,
                      mb: 2,
                      width: '100%', maxWidth: '600px',
                      color: 'black', 
                      // color: 'blue',
                      // fontWeight: 'bold', 
                      fontStyle: 'italic',
                    }}
                  >
                    To create a profile, the following profile elements are required
                  </Typography>
                  
                  {/* Stepper */}
                  {/* {bottomSteps.length > 2 && 
                    <Box
                      sx={{
                        width: '90%',
                        maxWidth: '600px',
                      }}
                    >
                      {stepperElement(bottomSteps, viewIndex, width, 3, 3)}
                    </Box>
                  } */}


                  {/* This must be first input So that the file upload only fires when you press the button */}
                  <Box sx={{ width: '100%' }}>
                    <Input type="text" autoFocus="autoFocus" />
                  </Box>

                  {viewIndex === 1 && mediaArray.length >= minimumOnboardingMedia
                    && nextButtonJSX()
                  }

                  {/* Vital Info */}
                  {viewIndex === 0 && 
                    vitalInfoOnboardingJSX(
                      vitalInfoObject, setVitalInfoObject, 
                      loadingVitalInfo, setLoadingVitalInfo,
                      vitalInfoErrors, setVitalInfoErrors,
                      width
                    )
                  }

                  {/* Media */}
                  {viewIndex === 1 && 
                    mediaOnboardingJSX(
                      user,
                      mediaArray, setMediaArray,
                      showCropCarousel, setShowCropCarousel,
                      loadingMedia, setLoadingMedia,
                      mediaErrors, setMediaErrors,
                      width
                    )
                  }

                  {/* Bio */}
                  {viewIndex === 2 && 
                    bioOnboardingJSX(
                      bioObject, setBioObject,
                      loadingBio, setLoadingBio,
                      bioErrors, setBioErrors,
                      width
                    )
                  }

                  {/* Back and Next/Finish Buttons */}
                  {!(viewIndex === 1 && mediaArray.length >= minimumOnboardingMedia) 
                    && nextButtonJSX()
                  }

                </Box>
              </>
        }
        

      </Box>

    </>
  )
}

export default Onboarding